module.exports = __webpack_public_path__ + "img/distractor-robot.c5cbd97f.png";